require('./beautician-price-request.less');
require('./../../blocks/attach-file/attach-file');
require('./../../blocks/drop-file/drop-file');



// WEBPACK FOOTER //
// ./blocks/beautician-price-request/beautician-price-request.js